/**
 * Created by senasanioglu on 8/15/16.
 */
define('casino/providers/NYX',['jquery'], function($) {
	'use strict';

	function NYX(casino, gameFunctions) {
		if (!(this instanceof NYX)) {
			throw new TypeError('NYX constructor cannot be called as a function.');
		}

		this.casino = casino;
		this.gameFunctions = gameFunctions;
	}

	function freeMode(nyx, game, options) {
		nyx.gameFunctions.hideHelpButton();
		var provider = nyx.casino.getProvider(game);
		var src = provider.url;

		var splitIdAndCode = game.code.split(/_(.+)?/);
		if (splitIdAndCode[0] !== 'NYX') {
			throw new Error('Illegal game code not starting with NYX: ' + game.code);
		}

		var $gameHolder = options.gameHolder;

		var $game = $gameHolder.find('.game');
		$game.empty();

			src = provider.url;
			src += $.param({
				nogsgameid: game.publishCode,
				nogsoperatorid: provider.partnerId,
				nogslang: provider.locale,
				nogsmode: 'demo',
				nogscurrency: "EUR",
				clienttype: (game.html5Format == 1) ? "html5" : "flash"
			});

		nyx.gameFunctions.switchToFreeMode(game, {
			gameHolder: options.gameHolder,
			type: 'iframe',
			src: src
		});
	}

	function realMode(nyx, game, options, data) {
		nyx.gameFunctions.hideHelpButton();
		var provider = nyx.casino.getProvider(game);
		var src = provider.url;

		var splitIdAndCode = game.code.split(/_(.+)?/);
		if (splitIdAndCode[0] !== 'NYX') {
			throw new Error('Illegal game code not starting with NYX: ' + game.code);
		}

		var $gameHolder = options.gameHolder;

		var $game = $gameHolder.find('.game');
		$game.empty();

			src = provider.url;
			src += $.param({
				accountid: data.playerReference,
				sessionid: splitIdAndCode[1] + '-' + data.sessionId,
				nogsgameid: game.publishCode,
				nogsoperatorid: provider.partnerId,
				nogslang: provider.locale,
				nogsmode: 'real',
				nogscurrency: data.currency,
				clienttype: (game.html5Format == 1) ? "html5" : "flash"
			});

		nyx.gameFunctions.switchToRealMode(game, {
			gameHolder: options.gameHolder,
			type: 'iframe',
			src: src
		});
		nyx.gameFunctions.verifyCurrency(data.currency);
	}

	NYX.prototype = {
		constructor: NYX,
		freeMode: function(game, options) { freeMode(this, game, options); },
		realMode: function(game, options, data) { realMode(this, game, options, data); }
	};

	return NYX;
});

